<!--  -->
<template>
  <div class="Banner">
    <div class="BannerIndex">
      <img :src="IndexBanner" />
    </div>
    <div class="Banner-text">
      <h1>
        <span>{{ Bannertitle }}</span
        ><br />{{ Bannertext }}
      </h1>
      <!-- <h1>{{Bannertext}}</h1> -->
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      //动态替换
      IndexBanner: "",
      Bannertitle: "",
      Bannertext: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          console.log(obj);
          if (!obj.region) {
            that.IndexBanner = require("../assets/CnBanner1.png");
          } else if (obj.region == 2) {
            that.IndexBanner = require("../assets/USBanner1.png");
          } else if (obj.region == 1) {
            that.IndexBanner = require("../assets/EUBanner.jpg");
          } else if (obj.region == 3) {
            that.IndexBanner = require("../assets/USBanner1.png");
          }
          if (obj.code == "0000") {
            that.Bannertitle = obj.data["kbyl"];
            that.Bannertext = obj.data["qqldz"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.get_fanyi();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../scss/public.scss";
.Banner {
  width: 100%;
  position: relative;
  // background-size: cover;
  background-size: 100%;
  .BannerIndex {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .Banner-text {
    background-color: rgba(7, 126, 193, 0.8);
    border-radius: 9px;
    padding: 30px 35px;
    position: absolute;
    bottom: 102px;
    left: 80px;
    h1 {
      font-size: 1.75rem;
      color: $text-color;
      line-height: 1.4;
      letter-spacing: 3px;
      span {
        font-size: 1.75rem;
        color: $text-color;
        line-height: 1.4;
        letter-spacing: 3px;
        font-weight: bold;
      }
    }
  }
}
@media screen and (max-width: 1500px) {
  .Banner {
    .Banner-text {
      padding: 20px 25px;
      left: 60px;
      h1 {
        font-size: 1.5rem;
      }
    }
  }
}
@media screen and (max-width: $main-width) {
  .Banner {
    .Banner-text {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/IndexBanner.vue